import { buttonHeights } from './buttonHeights';
export const buttonPaddings = {
    xsmall: '0.3125rem',
    small: '0.3475rem',
    medium: '0.5625rem',
    large: '0.6875rem',
};
export function getButtonPadding(height) {
    switch (height) {
        case buttonHeights.xsmall:
            return buttonPaddings.xsmall;
        case buttonHeights.small:
            return buttonPaddings.small;
        case buttonHeights.medium:
            return buttonPaddings.medium;
        case buttonHeights.large:
            return buttonPaddings.large;
        default:
            return buttonPaddings.xsmall;
    }
}
